/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaTpaNetwork } from '../../models/criteria-tpa-network';
import { ThirdPartyNetwork } from '../../models/third-party-network';

export interface ApiMasterThirdPartyNetworkGetByCriteriaPost$Params {
      body?: CriteriaTpaNetwork
}

export function apiMasterThirdPartyNetworkGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterThirdPartyNetworkGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ThirdPartyNetwork>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterThirdPartyNetworkGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ThirdPartyNetwork>>;
    })
  );
}

apiMasterThirdPartyNetworkGetByCriteriaPost.PATH = '/api/Master/ThirdPartyNetwork/GetByCriteria';
